"use strict";

angular.module("internal.exams").controller("InternalExamAutomationCorrespondence", [
    "$scope",
    "$state",
    "$stateParams",
    "MergeTemplates",
    "$window",
    "$rootScope",
    function ($scope, $state, $stateParams, MergeTemplates, $window, $rootScope) {

        $scope.loading = true;
        $scope.ExamTemplate = null;
        $scope.saveMessage = $stateParams.saveMessage;
        $scope.mergeIdName = 'Exams';
        $window.scrollTo(0, 0);

        if ($stateParams.examTemplateID != null) {
            MergeTemplates.getbyid($stateParams.examTemplateID).then(function (ExamTemplate) {
                $scope.ExamTemplate = ExamTemplate;
                $scope.loading = false;
            });
        } else {
            $scope.ExamTemplate = { active_merge_template: true };
        }
        $scope.save = function () {
            $scope.saving = true;
            if ($rootScope.enterprise.settings.email_provider_enabled) {
                $scope.ExamTemplate.from_address = $rootScope.enterprise.settings.email_provider_from_address;
            };
            MergeTemplates.save($scope.ExamTemplate).then(function (ExamTemplate) {
                $scope.saving = false;
                if (ExamTemplate != null) {
                    $state.go("internal.exams.administrative.correspondence", { examTemplateID: ExamTemplate.id, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };
        $scope.delete = function () {
            $scope.deleting = true;

            if ($scope.ExamTemplate.numexamtypes != null && $scope.ExamTemplate.numexamtypes > 0) {
                $scope.saveMessage = "Please remove the associated merge template from any exam type trigger(s) in order for deletion";
                $window.scrollTo(0, 0);
                $scope.deleting = false;
            } else {
                if (window.confirm("Are you sure you want to delete this merge template?")) {
                    MergeTemplates.delete($scope.ExamTemplate.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.correspondences", {}, {
                            reload: "internal.exams.administrative.correspondences"
                        });
                    });
                } else {
                    $scope.deleting = false;
                }
            }
        };
    }]);